<template>
	<span @click="$emit('acao')">
		<icone-simples-redondo-com-label
			label-botao="EP"
			texto="Estorno parcial"
			cor-background="grey"
		></icone-simples-redondo-com-label>
	</span>
</template>
<script>
import IconeSimplesRedondoComLabel from '@/views/components/icones/IconeSimplesRedondoComLabel.vue'

export default {
	name: 'icone-estornado-parcialmente',
	components: { IconeSimplesRedondoComLabel },
}
</script>
